import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { CompanyDocument } from "@ServerTypes/companies/companies.schema";

const initialState: CompanyDocument = {};

const companyDetailsSlice = createSlice({
  name: "companyDetails",
  initialState,
  reducers: {
    setCompanyDetails: (_state: CompanyDocument, action: PayloadAction<CompanyDocument>) => action.payload,
  },
});

export const { setCompanyDetails } = companyDetailsSlice.actions;

export const companyDetails = companyDetailsSlice.reducer;

export default companyDetailsSlice.reducer;
